// 自定义列信息
export const customColumns = [
  {
    key: 'sale_info',
    children: [
      {
        key: 'direct_sale',
        isSelected: false,
      },
      {
        key: 'sale',
        isSelected: false,
      },
    ],
  },

  {
    key: 'agent_adv',
    children: [
      {
        key: 'agent',
        isSelected: false,
      },
      {
        key: 'account',
        isSelected: false,
      },
      {
        key: 'category',
        isSelected: false,
      },
      {
        key: 'app_marketing_type',
        isSelected: false,
      },
    ],
  },

  {
    key: 'impression_click_cost',
    children: [
      {
        key: 'served_request',
        isSelected: true,
        isHover: true,
      },
      {
        key: 'cost_cash',
        isSelected: true,
        isHover: true,
      },
      {
        key: 'impression_total',
        isSelected: true,
        isHover: true,
      },
      {
        key: 'click_total',
        isSelected: true,
        isHover: true,
      },
      {
        key: 'cost_total',
        isSelected: true,
        isHover: true,
      },
      {
        key: 'cost_coupon',
        isSelected: true,
        isHover: true,
      },
    ],
  },

  {
    key: 'good_effect',
    children: [
      {
        key: 'cr',
        isSelected: false,
      },
      {
        key: 'acp',
        isSelected: false,
      },
      {
        key: 'ecpm',
        isSelected: false,
      },
      {
        key: 'list_ctr',
        isSelected: false,
      },
      {
        key: 'detail_ctr',
        isSelected: false,
      },
      {
        key: 'list_acp',
        isSelected: false,
        isHover: true,
      },
      {
        key: 'detail_acp',
        isSelected: false,
        isHover: true,
      },
      {
        key: 'list_ecpm',
        isSelected: false,
      },
      {
        key: 'detail_ecpm',
        isSelected: false,
      },
    ],
  },

  {
    key: 'plans_and_ideas',
    children: [
      {
        key: 'put_plans_num',
        isSelected: false,
        isHover: true,
      },
      {
        key: 'put_ideas_num',
        isSelected: false,
        isHover: true,
      },
      {
        key: 'new_ideas_num',
        isSelected: false,
        isHover: true,
      },
      // {
      //   key: 'idea_type',
      //   isSelected: false
      // },
      // {
      //   key: 'unit',
      //   isSelected: false
      // },
      // {
      //   key: 'is_ocpc',
      //   isSelected: false
      // }
    ],
  },
];

// 固定显示的表格列
export const fixedColumns = [
  {
    key: 'base_info',
    children: [
      {
        key: 'date',
      },
      {
        key: 'product',
      },
    ],
  },
];

// 折线图指标
export const fields = [
  'served_request',
  'impression_total',
  'click_total',
  'cost_total',
  'cost_cash',
  'cost_coupon',
];

// 包含涨幅数据的字段
export const fieldWithDiff = [
  'served_request',
  'cost_cash',
  'impression_total',
  'click_total',
  'cost_total',
  'cost_coupon',
  'acp',
  'ecpm',
  'list_acp',
  'detail_acp',
  'list_ecpm',
  'detail_ecpm',
  'put_ideas_num',
  'put_plans_num',
  'new_ideas_num',
];
